import { render, staticRenderFns } from "./xuetang.vue?vue&type=template&id=12fa9d7b&scoped=true"
import script from "./xuetang.vue?vue&type=script&lang=ts"
export * from "./xuetang.vue?vue&type=script&lang=ts"
import style0 from "./xuetang.vue?vue&type=style&index=0&id=12fa9d7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa9d7b",
  null
  
)

export default component.exports